'use strict';

import fd from "./promise-fastdom";

const _ = new WeakMap();

export default function ToggleButton(node) {
    _.set(this, {
        node: node
    });
}

/**
 * @returns {Promise<ReturnType<function(): ToggleButton>>}
 */
ToggleButton.prototype.init = function () {
    return fd.mutate(() => {
        const o = _.get(this);
        const button = document.createElement('button');
        button.setAttribute('aria-expanded', false);
        button.type = 'button';
        button.innerHTML = o.node.innerHTML;
        o.button = button;

        o.node.innerHTML = '';
        o.node.appendChild(button);

        return this;
    });
}

ToggleButton.prototype.node = function () {
    return _.get(this).node;
}

ToggleButton.prototype.button = function () {
    return _.get(this).button;
}

ToggleButton.prototype.destroy = function () {
    return fd.mutate(() => {
        const o = _.get(this);
        o.node.innerHTML = o.button.innerHTML;
    });
}
